import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {"display":"block"},
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<circle cx=\"7\" cy=\"7\" r=\"6.5\" fill=\"var(--fill-0, #5B99E2)\" stroke=\"var(--stroke-0, #5B99E2)\"></circle><g clip-path=\"url(#a)\"><path fill=\"var(--fill-0, white)\" d=\"M7 6.376 9.25 4.129a.44.44 0 0 1 .623.001.444.444 0 0 1-.002.626L7.625 7 9.87 9.244a.443.443 0 0 1 .002.626.44.44 0 0 1-.623 0L7 7.625 4.752 9.87A.439.439 0 0 1 4 9.556c0-.117.047-.23.13-.312L6.376 7 4.13 4.756A.444.444 0 0 1 4.44 4a.44.44 0 0 1 .312.129z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M4 4h6v6H4z\"></path></clipPath></defs>", 3)
  ]))]))
}
export default { render: render }